import React from "react";
import { TopToolbar, Button } from "react-admin";
import RefreshIcon from "@material-ui/icons/Refresh";
import { BackButton } from "../../../../components/common/BackButton";
import { HelpButton } from "../../../../components/common/HelpButton";
import { useTrackContext } from "../TrackContext";

/**
 * ListActions component for track management toolbar actions
 * Consumes from TrackContext to reduce prop drilling
 */
export const ListActions = (props) => {
  const { backPath, getTrackCars, getTracks } = useTrackContext();

  const handleRefresh = () => {
    // TrackContext provides no-op defaults, so these are always safe to call
    getTrackCars({ showSpinner: true });
    getTracks({ showSpinner: true });
  };
  
  return (
    <TopToolbar {...props}>
      <HelpButton />
      <span
        id="track-management-refresh"
        data-productly="track-management-refresh"
      >
        <Button
          label="Refresh"
          onClick={handleRefresh}
          color="primary"
        >
          <RefreshIcon />
        </Button>
      </span>
      {backPath && backPath[0] && <BackButton backPath={backPath} />}
    </TopToolbar>
  );
};

